import MembersTable from './MembersTable.component';

export default MembersTable;